"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState } from "react";
import localFont from "next/font/local";
import { cn } from "@shared-utils/ui";
import type { ThemeMode } from "@shared-database/schema";
import { api } from "@shared-server/api";
export type ThemeContainer = "" | "default-font-small";
type ThemeContextType = {
  themeMode: ThemeMode;
  toggleThemeMode: () => void;
};
const ibmPlexSans = localFont({
  src: [{
    path: "../../assets/font/IBMPlexSans-Regular.ttf",
    weight: "400",
    style: "normal"
  }, {
    path: "../../assets/font/IBMPlexSans-Medium.ttf",
    weight: "500",
    style: "normal"
  }, {
    path: "../../assets/font/IBMPlexSans-Bold.ttf",
    weight: "700",
    style: "normal"
  }],
  variable: "--font-ibm-plex-sans",
  display: "swap"
});
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export const ThemeProvider = props => {
  const $ = _c(16);
  const [themeMode, setThemeMode] = useState(props.themeMode);
  const {
    mutate: updateThemeMutation
  } = api.users.updateTheme.useMutation();
  let t0;
  if ($[0] !== props.ableToUpdateTheme || $[1] !== themeMode || $[2] !== updateThemeMutation) {
    t0 = () => {
      const newThemeMode = themeMode === "dark" ? "light" : "dark";
      setThemeMode(newThemeMode);
      document.cookie = `theme=${newThemeMode}; path=/; max-age=${157680000000}`;
      if (!props.ableToUpdateTheme) {
        return;
      }
      updateThemeMutation({
        themeMode: newThemeMode
      });
    };
    $[0] = props.ableToUpdateTheme;
    $[1] = themeMode;
    $[2] = updateThemeMutation;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const toggleThemeMode = t0;
  let t1;
  if ($[4] !== themeMode || $[5] !== toggleThemeMode) {
    t1 = {
      themeMode,
      toggleThemeMode
    };
    $[4] = themeMode;
    $[5] = toggleThemeMode;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props.themeContainer || $[8] !== themeMode) {
    t2 = cn(ibmPlexSans.variable, themeMode, props.themeContainer);
    $[7] = props.themeContainer;
    $[8] = themeMode;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== props.children || $[11] !== t2) {
    t3 = <html className={t2}>{props.children}</html>;
    $[10] = props.children;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t1 || $[14] !== t3) {
    t4 = <ThemeContext.Provider value={t1}>{t3}</ThemeContext.Provider>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const useThemeMode = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};